import React from 'react';
import { Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import UserLink from '../../User/Link/UserLink';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import HiddenLayout from './HiddenLayout';
import { HiddenProps } from './types';
import Hidden from './Icons/Hidden';
import { BiData, RedirectToLoginBiEvent } from '@wix/da-bi/pkg/events';

import hiddenStyles from './Hidden.scss';

const AntisocialBlockedOverlay: React.FC<HiddenProps> = ({
  deviation: { author },
  deviation,
  ...props
}) => {
  return (
    <HiddenLayout
      icon={<Hidden />}
      text={[
        /* prettier-ignore */
        author && <Trans key="antisocial" i18nKey="deviationview.blocked.antisocial">
          <UserLink user={author} className={hiddenStyles['link']} /> has limited the
          viewing of this artwork to members of the DeviantArt
          community only.
        </Trans>,
        /* prettier-ignore */
        <Trans key="antisocial-cta" i18nKey="deviationview.blocked.antisocial.loginOrJoin">
          You can{' '}
          <a
            href={Url.loginLink()}
            className={hiddenStyles['link']}
          >
            log in
          </a>{' '}
          or{' '}
          <BiLink
            href={Url.joinLink()}
            className={hiddenStyles['link']}
            biData={BiData<RedirectToLoginBiEvent>({
              evid: 240,
              referral_info: ReferralType.ANTISOCIAL,
            })}
          >
            become a member
          </BiLink>{' '}
          for FREE.
        </Trans>,
      ]}
      deviation={deviation}
      {...props}
    />
  );
};
AntisocialBlockedOverlay.displayName = 'AntisocialBlockedOverlay';

export default AntisocialBlockedOverlay;
